export default "__VITE_ASSET__DTpJBxJw__"